import React, { Component } from "react";
import moment from "moment";
import AdmissionApi from "../../../Services/AdmissionApi";

import "./style.css";

class AdminDashboard extends Component {
  admissionsService = new AdmissionApi()

  state = {
    stats: {
      allTime: null,
      month: null,
      today: null
    },
    selectedStudentStat: 'allTime',
    selectedAdmnAlertStat: 'allTime',
    selectedScholarshipStat: 'allTime',
    selectedCareerStat: 'allTime',
    ads: [],
    allCategories: []
  }

  cbAdminDashboard = newResponse => {
    const response = newResponse.data
    if (response.success) {
      this.setState({ stats: response.data });
    }
  }

  componentDidMount() {
    this.admissionsService.GetData(
      this.cbAdminDashboard,
      "v1/alerts/dashboard/stats"
    )

    this.getAllCategories()
  }

  getAdvData = () => {
    let formData = new FormData()
    formData.append('sortParam', 'createdAt')
    formData.append('sortBy', 'desc')
    formData.append('perPage', 5)
    formData.append('filterByCount', '1')
    formData.append('filterByLiveAdv', '1')

    this.admissionsService.getAds(
      (res) => this.setState({ ads: res.data._embedded.Advertisements }),
      `v1/advertisement/list?page=1`,
      formData
    )
  }

  cbCourseCategories = (newResponse) => {
    if (newResponse.data.success) {
      const _categories = newResponse.data._embedded.category

      const allCategories = _categories.map(item => ({
        label: item.name,
        value: item.id,
      }))

      this.setState({ allCategories }, this.getAdvData);
    }
  }

  getAllCategories = () => {
    this.admissionsService.GetData(
      this.cbCourseCategories,
      "v1/students/alert/category"
    )
  }

  handleChange = (e) => {
    const { id, value } = e.target
    this.setState({ [id]: value })
  }

  render() {
    const { updateRoutePage } = this.props

    const {
      stats,
      selectedStudentStat,
      selectedAdmnAlertStat,
      selectedScholarshipStat,
      selectedCareerStat,
      ads,
      allCategories
    } = this.state

    const options = [
      { label: 'Total', value: 'allTime' },
      { label: 'This Month', value: 'month' },
      { label: 'Today', value: 'today' }
    ]

    return (
      <div className="row">
        <div className="col-sm-12 col-lg-6">
          <div className="dash-status dash-status--yellow">
            <div className="d-flex justify-content-between align-items-end">
              <h3 className="m-0">Students</h3>
              <select
                id="selectedStudentStat"
                className="custom-select custom-select-sm"
                value={selectedStudentStat}
                onChange={this.handleChange}
              >
                {options.map((item, i) => (
                  <option key={i} value={item.value}>{item.label}</option>
                ))}
              </select>
            </div>
            <p>{stats[selectedStudentStat] ? stats[selectedStudentStat].studentRegistered : 0}</p>
          </div>
        </div>
        <div className="col-sm-12 col-lg-6">
          <div className="dash-status dash-status--pink">
            <div className="d-flex justify-content-between align-items-end">
              <h3 className="m-0">Admission Alerts</h3>
              <select
                id="selectedAdmnAlertStat"
                className="custom-select custom-select-sm"
                value={selectedAdmnAlertStat}
                onChange={this.handleChange}
              >
                {options.map((item, i) => (
                  <option key={i} value={item.value}>{item.label}</option>
                ))}
              </select>
            </div>
            <p>{stats[selectedAdmnAlertStat] ? stats[selectedAdmnAlertStat].admissionAlert : 0}</p>
          </div>
        </div>
        <div className="col-sm-12 col-lg-6">
          <div className="dash-status dash-status--aqua">
            <div className="d-flex justify-content-between align-items-end">
              <h3 className="m-0">Scholarship</h3>
              <select
                id="selectedScholarshipStat"
                className="custom-select custom-select-sm"
                value={selectedScholarshipStat}
                onChange={this.handleChange}
              >
                {options.map((item, i) => (
                  <option key={i} value={item.value}>{item.label}</option>
                ))}
              </select>
            </div>
            <p>{stats[selectedScholarshipStat] ? stats[selectedScholarshipStat].scholarshipAlert : 0}</p>
          </div>
        </div>
        <div className="col-sm-12 col-lg-6">
          <div className="dash-status dash-status--purple">
            <div className="d-flex justify-content-between align-items-end">
              <h3 className="m-0">Career</h3>
              <select
                id="selectedCareerStat"
                className="custom-select custom-select-sm"
                value={selectedCareerStat}
                onChange={this.handleChange}
              >
                {options.map((item, i) => (
                  <option key={i} value={item.value}>{item.label}</option>
                ))}
              </select>
            </div>
            <p>{stats[selectedCareerStat] ? stats[selectedCareerStat].career : 0}</p>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="d-flex justify-content-between align-items-center">
            <h3 style={{fontWeight: 'bold'}}>Top 5 Advertisements</h3>
            <div onClick={() => updateRoutePage('advertisement')} to="/AdmissionAlerts" className="btn btn-link dash-list__btn">View All &rarr;</div>
          </div>
          <table className="table table-responsive alert-table">
            <thead>
              <tr>
                <th scope="col">Ad</th>
                <th scope="col">University</th>
                <th scope="col">Course Category</th>
                <th scope="col">Total Clicks</th>
                <th scope="col">Live Until</th>
              </tr>
            </thead>
            <tbody>
              {ads.length 
                ? ads.map(item => (
                  <tr key={item.id}>
                    <td>
                      <img className="career-img" src={item.fileUrl} alt="Ad1" />
                    </td>
                    <td>{item.university.name}</td>
                    <td>{item.advertisementCategory.map(item => allCategories.find(cat => cat.value == item.categoryId).label).join(', ')}</td>
                    <td>{item.totalClickCount}</td>
                    <td>{moment(item.liveUntil).format('DD/MM/YYYY')}</td>
                  </tr>
                ))
                : (
                  <tr>
                    <td colSpan={4}>No Advertisement Found!</td>
                  </tr>
                )
              }
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

export default AdminDashboard



/** WEBPACK FOOTER **
 ** ./src/components/Admin/AdminDashboard/index.js
 **/